import { AsyncAction } from "../../store";
import {
  AuthAction,
  LOAD_AUTH_USER,
  LOAD_AUTH_USER_SUCCESS,
  LOAD_AUTH_USER_FAIL,
  LOGIN,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGIN_KEYCLOAK,
  LOGOUT_KEYCLOAK
} from "./actionTypes";

// TODO: Exported as `loadAuth`
// TODO: auth state
export function load(user: any): AsyncAction {
  return {
    types: [LOAD_AUTH_USER, LOAD_AUTH_USER_SUCCESS, LOAD_AUTH_USER_FAIL],
    promise: (client) =>
      client.get(`/user/${user.username}`, {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      }),
  };
}

export function login(username: string, password: string): AsyncAction {
  return {
    types: [LOGIN, LOGIN_SUCCESS, LOGIN_FAIL],
    username,
    promise: (client) =>
      client.post("/auth/login", {
        data: {
          username,
          password,
        },
        headers: { "Content-Type": "application/json" },
      }),
  };
}

export function logout(): AuthAction {
  return {
    type: LOGOUT_KEYCLOAK
  }
}

export function login_keycloak(username:string,token:string) :AuthAction{
  return {
    type: LOGIN_KEYCLOAK,
    username,
    token
  }
}
